// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"791e9a36","117":"c8c9640f","131":"e7927fa1","268":"1abd527c","317":"b251e461","472":"9d928348","641":"dbe85247","687":"f55122d3","906":"826e6218"}[chunkId] + ".chunk.js";
};